<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    width="70em"
    backdrop
    no-header
    right
    @hidden="resetuserData"
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
  >

    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Create New User')}}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner
            :animation-duration="1000"
            :size="100"
            :color="'#0e96b1'"
        />
      </div>

      <!-- BODY -->
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="onSubmit">

          <b-row>

            <b-col cols="6">
              <!-- Name -->
              <b-form-group :label="$t('Name')" label-for="name">
                <b-form-input
                    id="name"
                    v-model="userData.name"
                    autofocus
                    :state="(errors && ('name' in errors)) ? false : null"
                    trim
                    autocomplete="off"
                    placeholder=""
                />

                <b-form-invalid-feedback v-if="errors && ('name' in errors)" :state="(errors && ('name' in errors)) ? false : null">
                  {{  $t(errors.name[0])  }}
                </b-form-invalid-feedback>

              </b-form-group>
            </b-col>


            <b-col cols="6">
              <!-- Email -->
              <b-form-group :label="$t('Email')" label-for="email">
                <b-form-input
                    id="email"
                    autocomplete="off"
                    v-model="userData.email"
                    :state="(errors && ('email' in errors)) ? false :  null"
                    trim
                />

                <b-form-invalid-feedback v-if="(errors && ('email' in errors))" :state="(errors && ('email' in errors)) ? false : null">
                  {{ $t(errors.email[0])  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <!-- User expire date -->
              <b-form-group :label="$t('User Expire Date')" label-for="user-expire-date" :state="null">
                <flat-pickr
                    v-model="userData.expire_at"
                    :state="null"
                    class="form-control"
                    :config="{ dateFormat: 'Y-m-d', minDate: new Date(Date.now() + (3600 * 1000 * 24))}"
                    placeholder="YYYY-MM-DD"
                />
                <b-form-invalid-feedback v-if="errors && ('expire_at' in errors)" :state="(errors && ('expire_at' in errors)) ? false :  null">
                  {{  $t(errors.expire_at[0])  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row>

<!--            <b-col cols="6">-->
<!--              &lt;!&ndash; Manger &ndash;&gt;-->
<!--              <b-form-group :label="$t('Manager')" label-for="manager" :state="null">-->
<!--                <v-select-->
<!--                    v-model="userData.manager_id"-->
<!--                    label="name"-->
<!--                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
<!--                    :options="managersOptions"-->
<!--                    :reduce="val => val.id"-->
<!--                    :clearable="false"-->
<!--                    input-id="manager"-->
<!--                />-->
<!--                <b-form-invalid-feedback v-if="(errors && ('manager_id' in errors))" :state="(errors && ('manager_id' in errors)) ? false : null">-->
<!--                  {{ $t(errors.manager_id[0])  }}-->
<!--                </b-form-invalid-feedback>-->
<!--              </b-form-group>-->
<!--            </b-col>-->

<!--            <b-col cols="6">-->
<!--              &lt;!&ndash; User Role &ndash;&gt;-->
<!--              <b-form-group :label="$t('User Role')" label-for="user-role" :state="null">-->
<!--                <v-select-->
<!--                    v-model="userData.role"-->
<!--                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
<!--                    :options="rolesOptions"-->
<!--                    :reduce="val => val.value"-->
<!--                    label="label"-->
<!--                    :clearable="false"-->
<!--                    input-id="user-role"-->
<!--                />-->
<!--                <b-form-invalid-feedback v-if="(errors && ('role' in errors))" :state="(errors && ('role' in errors)) ? false : null">-->
<!--                  {{ $t(errors.role[0])  }}-->
<!--                </b-form-invalid-feedback>-->
<!--              </b-form-group>-->
<!--            </b-col>-->

          </b-row>



<!--          <b-row>-->

<!--            <b-col cols="6">-->
<!--              &lt;!&ndash; Manger &ndash;&gt;-->
<!--              <b-form-group :label="$t('Contract')" label-for="contract" :state="null">-->
<!--                <v-select-->
<!--                    v-model="userData.contract_id"-->
<!--                    label="name"-->
<!--                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
<!--                    :options="contractsOptions"-->
<!--                    :reduce="val => val.id"-->
<!--                    :clearable="false"-->
<!--                    input-id="contract"-->
<!--                />-->
<!--                <b-form-invalid-feedback v-if="(errors && ('contract_id' in errors))" :state="(errors && ('contract_id' in errors)) ? false : null">-->
<!--                  {{ $t(errors.contract_id[0])  }}-->
<!--                </b-form-invalid-feedback>-->
<!--              </b-form-group>-->

<!--            </b-col>-->


            <b-col cols="6">

            </b-col>

<!--          </b-row>-->


<!-- create user from admin account select role start -->
<div v-if="$store.state.auth.userData.roles.includes('Super Admin')">
        <b-row>
      <b-col cols="6" md="6">
        <!-- left char -->
        <b-form-group :label="$t('Is manager')" label-for="plate-left-char">
          <b-form-checkbox v-model="userData.isManager" :value="true"   />

          <small v-if="errors && ('isManager' in errors)" class="text-danger">
            {{ $t(errors['isManager'][0]) }}
          </small>

        </b-form-group>
      </b-col>

     
      <b-col v-if="!userData.isManager"  cols="6" md="6">
          <b-form-group :label="$t('The Manager')" label-for="user-status">
            <v-select v-model="userData.manager_id" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="[...managersOptions]"
               :reduce="val => val.id"
                label="name" 
                 :clearable="false"
              input-id="user-status" />
            <small v-if="errors && ('manager_id' in errors)" class="text-danger">
              {{ $t(errors['manager_id'][0]) }}
            </small>
          </b-form-group>
        </b-col>

      </b-row>
      </div>
    
     
      
      
 <!-- create user from admin account select role  end -->


          <b-row>

            <b-col cols="6">

              <!-- password -->
              <b-form-group
                  :label="$t('Password')"
                  label-for="Password"
              >
                <b-form-input
                    id="password"
                    type="password"
                    autocomplete="new-password"
                    v-model="userData.password"
                    :state="(errors && ('password' in errors)) ? false : null"
                    trim
                />

                <b-form-invalid-feedback v-if="errors && ('password' in errors)" :state="(errors && ('password' in errors)) ? false : null">
                  {{ $t(errors.password[0])  }}
                </b-form-invalid-feedback>

              </b-form-group>

            </b-col>

            <b-col cols="6">
              <!-- password confirmation -->
              <b-form-group
                  :label="$t('Password Confirmation')"
                  label-for="Password_confirmation"
              >
                <b-form-input
                    type="password"
                    id="password_confirmation"
                    autocomplete="new-password"
                    v-model="userData.password_confirmation"
                    :state="(errors && ('password_confirmation' in errors)) ? false : null"
                    trim
                />

                <b-form-invalid-feedback v-if="errors && ('password_confirmation' in errors)" :state="(errors && ('password_confirmation' in errors)) ? false : null">
                  {{ $t(errors.password_confirmation[0])  }}
                </b-form-invalid-feedback>
              </b-form-group>

            </b-col>

          </b-row>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ $t('Add')}}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="resetuserData">
              {{ $t('Cancel')}}
            </b-button>
          </div>
        </b-form>

    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,BFormCheckbox,
    BRow,BCol
} from 'bootstrap-vue'
import { ref ,watch} from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,BRow,BCol,
    BFormInvalidFeedback,
    BFormCheckbox,
    BButton,
    vSelect,
    OrbitSpinner,

    flatPickr,

  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    managersOptions: {
      type: Array,
      required: true,
    },
    contractsOptions: {
      type: Array,
      required: true,
    },

  },
  setup(props, { emit }) {
    const auth = store.getters['auth/user']
    const blankUserData = {
      name: '',
      email: '',
      role_id: null,
      enabled: null,
      manager_id: '',
      contract_id: '',
      expire_at: '',
      password: '',
      password_confirmation: '',
      isManager:false,
      manager_id:0
    }


    const errors = ref(null)

    const requestStatus = ref(false)

    const userData = ref(JSON.parse(JSON.stringify(blankUserData)))
    const resetuserData = () => {
      userData.value = JSON.parse(JSON.stringify(blankUserData))
    }
     
    const rolesOptions = [
      {label:"Manager", value:'manager'},
      {label:"User", value:'user'}
    ]





      watch(userData.value,()=>{
       
   if(userData.value.isManager){
 
     delete  userData.value.manager_id;
   


   }
  
 })

    const onSubmit = () => {

      if (userData.value.isManager == true) { delete userData.value.manager_id }
      requestStatus.value = true
      store.dispatch('appUser/addUser', userData.value)
        .then(() => {
          requestStatus.value = false
          emit('refetch-data')
          emit('update:is-add-new-user-sidebar-active', false)
        }).catch(res => {
          requestStatus.value = false
          if (res.response.status === 422) {
            errors.value = res.response.data.errors
          }
         }
        )
    }



    return {
      userData,
      rolesOptions,
      onSubmit,
      resetuserData,
      requestStatus,
      errors,
     // managersOptions
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
